// This is an attempt at building a generic hook that can be used to validate
// any form input before submitting. It is currently a work
// in progress and only being used on the "Launch a new workflow" form
// but in theory can be used any on other forms such as organization details, etc.
//
// It supports multiple points of verification:
// 1. Requires that a value be provided
// 2. Requires that a value be certain length
// 3. Requires that a value match regex
// 4. Requires that a value pass custom checks
//
// Custom helper text can be passed to display back to user, this is
// only currently supported if using custom checks but should be
// extended to other checks as well.

// TODO: Replace with react form hook
export class FormValidationError {
  message: string;

  constructor(msg?: string) {
    this.message = msg;
  }
}
interface Validation {
  required?: boolean;
  minLength?: number;
  pattern?: string;
  skip?: boolean;
  custom?: () => FormValidationError;
}

type Validations<T extends Record<string, unknown>> = Partial<Record<keyof T, Validation>>;

type ErrorRecord<T> = Partial<Record<keyof T, any>>;

const useForm = <T extends Record<keyof T, unknown>>(options?: {
  validations?: Validations<T>;
  data: any;
  setError?: (ErrorRecord) => void;
}) => {
  const error: ErrorRecord<T> = {};

  const validate = () => {
    const validations = options?.validations;
    const data = options?.data;
    if (validations) {
      let valid = true;
      for (const key in validations) {
        const value = data[key];
        const validation = validations[key];
        if (validation.skip) {
          continue;
        }

        if (validation?.required && !value) {
          valid = false;
          error[key] = {
            has: true,
          };
        }

        if (validation?.minLength && value.length < validation?.minLength) {
          valid = false;
          error[key] = {
            has: true,
          };
        }

        const pattern = validation?.pattern;
        if (pattern && !RegExp(pattern).test(value)) {
          valid = false;
          error[key] = {
            has: true,
          };
        }

        const custom = validation?.custom;
        if (custom) {
          const inputError: FormValidationError = custom();
          if (inputError) {
            valid = false;
            error[key] = {
              has: true,
            };

            if (inputError.message) {
              error[key].msg = inputError.message;
            }
          }
        }
      }

      if (!valid) {
        options.setError(error);
        return false;
      }

      return true;
    }
  };

  return {
    validate,
  };
};

export default useForm;
